export const REVISION_KEY_SEPARATOR = ':';
